export default __webpack_public_path__ + "55a1124d65b24d1183710a815d852512.svg";